import * as THREE from 'three'
import GUI from 'lil-gui'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'
import gsap from 'gsap'



/**
 * Debug
 */
const gui = new GUI()

const parameters = {
    materialColor: '#ffeded',
    particlesWaveRotationX: 0.168407,
    particlesWaveRotationY: 0.168407,
    particlesWaveRotationZ: -3.14159,
    particlesWaveSize: 0.01,
    waveScale: 2,
    waveAmplitude: 0.1,
    waveFrequency: 0.2,
    wavePositionY: -0.19999     
}

//Folders GUI
const particlesWaveFolder = gui.addFolder('Particles Wave')
const textMeshFolder = gui.addFolder('Text Mesh')

gui.close()
particlesWaveFolder.close()
textMeshFolder.close()


gui
    .addColor(parameters, 'materialColor')
    .onChange(() =>
    {
        material.color.set(parameters.materialColor)
        particlesMaterial.color.set(parameters.materialColor)
    })

/**
 * Loaders
 */
const loadingBarElement = document.querySelector('.loading-bar')



const loadingManager = new THREE.LoadingManager(
    //Loaded
    () =>
    {
        window.setTimeout(() =>
        {
        gsap.to(overlayMaterial.uniforms.uAlpha, { duration: 3, value: 0 })
        loadingBarElement.classList.add('ended')
        loadingBarElement.style.transform = ''
        
    }, 500)
    },

    //Progress
    (itemUrl, itemLoaded, itemsTotal) =>
    {
        const progressRatio = itemLoaded / itemsTotal
        loadingBarElement.style.transform = `scaleX(${progressRatio})`
    
    }
)



/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()


/**
 * Overlay
 */
const overlayGeometry = new THREE.PlaneGeometry(2, 2, 1, 1)
const overlayMaterial = new THREE.ShaderMaterial({
    transparent: true,
    uniforms: {
        uAlpha: { value: 1 }
    },
    vertexShader:`
        void main()
        {
            gl_Position =  vec4(position, 1.0);
        }
        `,
    fragmentShader: `
        uniform float uAlpha;
        void main()
        {
            gl_FragColor = vec4(0.0, 0.0, 0.0, uAlpha);
        }
     ` 

})

const overlay = new THREE.Mesh(overlayGeometry, overlayMaterial)
scene.add(overlay)


/**
 * Fonts
 */

const fontLoader = new FontLoader(loadingManager)
let textMeshEscolha, textMeshDigital;


fontLoader.load('/fonts/Montserrat_Regular.json', (fontRegular) => {
    const textGeometryEscolha = new TextGeometry('escolha', {
        font: fontRegular,
        size: 0.5,
        depth: 0.2,
        curveSegments: 5,
        bevelEnabled: true,
        bevelThickness: 0.03,
        bevelSize: 0.02,
        bevelOffset: 0,
        bevelSegments: 5,
    });

    

    const textMaterialEscolha = new THREE.MeshStandardMaterial({
        color: 0xffffff, 
        metalness: 0.6, 
        roughness:0, 
    });

    textMeshEscolha = new THREE.Mesh(textGeometryEscolha, textMaterialEscolha);

    textMeshEscolha.position.set(-2.4, 0.46, -1.31); 
    scene.add(textMeshEscolha);
});


fontLoader.load('/fonts/Montserrat_Bold.json', (fontBold) => {
    const textGeometryDigital = new TextGeometry('digital', {
        font: fontBold,
        size: 0.5,
        depth: 0.2,
        curveSegments: 5,
        bevelEnabled: true,
        bevelThickness: 0.03,
        bevelSize: 0.02,
        bevelOffset: 0,
        bevelSegments: 5,
    });

    const textMaterialDigital = new THREE.MeshStandardMaterial({
        color: 0xffffff, 
        metalness: 0, 
        roughness: 0, 
    });

    textMeshDigital = new THREE.Mesh(textGeometryDigital, textMaterialDigital);

    
    textMeshDigital.position.set(0.25, 0.46, -1.31); 

    scene.add(textMeshDigital);

    }
)



/**
 * Objects
 */
//Textures
const textureLoader = new THREE.TextureLoader(loadingManager)

const matcapTexture = textureLoader.load('/matcaps/10.png')
matcapTexture.colorSpace = THREE.SRGBColorSpace

const gradientTexture = textureLoader.load('/gradients/3.jpg')
gradientTexture.magFilter = THREE.NearestFilter
gradientTexture.minFilter = THREE.NearestFilter

const particleWaveTexture = textureLoader.load(
    '/particles/3.png',
    () => {
        console.log('Particle wave texture loaded successfully');
    },
    undefined,
    (error) => {
        console.error('Error loading particle wave texture:', error);
    }
);


//Material
const material = new THREE.MeshToonMaterial({ 
    color: parameters.materialColor,
    gradientMap: gradientTexture,
})

//Meshs
const objectsDistance = 4

const mesh1= new THREE.Mesh(
    new THREE.TorusGeometry(1, 0.4, 16, 60),
    material
    )

const mesh2= new THREE.Mesh(
    new THREE.ExtrudeGeometry(
        new THREE.Shape([
            new THREE.Vector2(0, 0),
            new THREE.Vector2(1, 0),
            new THREE.Vector2(1, 1),
            new THREE.Vector2(0, 1)
        ]),
        {
            depth: 1,
            bevelEnabled: true,
            bevelThickness: 0.3,
            bevelSize: 0.2,
            bevelSegments: 3
        }
    ),material
    )

const mesh3= new THREE.Mesh(
    new THREE.TorusKnotGeometry(0.5, 0.2, 100, 16),
    material
    )

 const mesh4= new THREE.Mesh(
    new THREE.DodecahedronGeometry(1),
    material
    )

const mesh5= new THREE.Mesh(
    new THREE.CapsuleGeometry(0.5, 1, 16),
    material
    )

mesh1.position.y = -objectsDistance * 1
mesh2.position.y = -objectsDistance * 2
mesh3.position.y = -objectsDistance * 3
mesh4.position.y = -objectsDistance * 4
mesh5.position.y = -objectsDistance * 5

mesh1.position.x = 2
mesh2.position.x = -2
mesh3.position.x = 2
mesh4.position.x = -2
mesh5.position.x = 2

scene.add(mesh1, mesh2, mesh3, mesh4, mesh5)

const sectionMeshes = [mesh1, mesh2, mesh3, mesh4, mesh5]



/**
 * Raycaster
 */
const raycaster = new THREE.Raycaster()



/**
 * Particles
 */
//Geometry
const particlesCount = 1000
const positions = new Float32Array(particlesCount * 3)

for (let i = 0; i < particlesCount * 3; i++)
{
    positions[i * 3 + 0] = (Math.random() - 0.5) * 10
    positions[i * 3 + 1] = objectsDistance * 0.5 - Math.random() * objectsDistance * 6 //sectinMeshes.length
    positions[i * 3 + 2] = (Math.random() - 0.5) * 10
}

const particlesGeometry = new THREE.BufferGeometry()
particlesGeometry.setAttribute(
    'position', 
    new THREE.BufferAttribute(positions, 3)
)

//Material
const particlesMaterial = new THREE.PointsMaterial({
    color: parameters.materialColor,
    sizeAttenuation: true,
    size: 0.03,
    alphaMap: particleWaveTexture,
    transparent: true,
    depthWrite: false
    
})

//Points
const particles = new THREE.Points(particlesGeometry, particlesMaterial)
scene.add(particles)



//Wave particles geometry
const particlesWaveGeometry = new THREE.BufferGeometry()
const count = 10000;

const positionsWave = new Float32Array(count * 3)


for( let i = 0; i < count * 3; i++)
{
    positionsWave[i] = (Math.random() - 0.5) * 10
}

particlesWaveGeometry.setAttribute(
    'position', 
    new THREE.BufferAttribute(positionsWave, 3)
)
particlesWaveGeometry.attributes.position.needsUpdate = true;

//Wave particles material
const particlesWaveMaterial = new THREE.PointsMaterial({
    color: parameters.materialColor,
    size: 0.01,
    sizeAttenuation: true,
    alphaMap: particleWaveTexture,
    transparent: true,
    depthWrite: false,
    blending: THREE.AdditiveBlending
  

})

//Wave particles points
const particlesWave = new THREE.Points(particlesWaveGeometry, particlesWaveMaterial)
//scene.add(particlesWave)

particlesWaveFolder.add(parameters, 'particlesWaveRotationX').min(-Math.PI).max(Math.PI).step(0.01).name('Wave Rotation X')
particlesWaveFolder.add(parameters, 'particlesWaveRotationY').min(-Math.PI).max(Math.PI).step(0.01).name('Wave Rotation Y')
particlesWaveFolder.add(parameters, 'particlesWaveRotationZ').min(-Math.PI).max(Math.PI).step(0.01).name('Wave Rotation Z')
particlesWaveFolder.add(parameters, 'particlesWaveSize').min(0.01).max(1).step(0.01).name('Wave Size').onChange(() => {
    particlesWaveMaterial.size = parameters.particlesWaveSize
})
particlesWaveFolder.add(parameters, 'waveScale').min(0.1).max(2).step(0.1).name('Wave Scale').onChange(() => {
    particlesWave.scale.set(parameters.waveScale, parameters.waveScale, parameters.waveScale)
})
particlesWaveFolder.add(parameters, 'waveAmplitude').min(0.1).max(2).step(0.1).name('Wave Amplitude')
particlesWaveFolder.add(parameters, 'wavePositionY').min(-5).max(5).step(0.1).name('Wave Position Y')
particlesWaveFolder.add(parameters, 'waveFrequency').min(0.1).max(10).step(0.1).name('Wave Frequency')



/**
 * Lights
 */
const directionalLight = new THREE.DirectionalLight('#ffffff', 3)
directionalLight.position.set(1, 1, 0)
scene.add(directionalLight)

const ambientLight = new THREE.AmbientLight(0xffffff, 2); // Luz ambiente suave
scene.add(ambientLight);



/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})




/**
 * Camera
 */
const cameraGroup = new THREE.Group()
scene.add(cameraGroup)

// Base camera
const camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 6
cameraGroup.add(camera)




/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))



/**
 * Scroll section
 */
let scrollY = window.scrollY
let currentSection = 0

window.addEventListener('scroll', () =>
{
    scrollY = window.scrollY

    const newSection = Math.round(scrollY / sizes.height)
    if (newSection != currentSection)
    {
        currentSection = newSection

        if (currentSection > 0 && sectionMeshes[currentSection - 1]) {
            gsap.to(sectionMeshes[currentSection - 1].rotation,
            {
                duration: 2,
                ease: 'power2.inOut',
                x: '+=6',
                y: '+=3',
                z: '+=1.5',
                })

    }
}
})



/**
 * Mouse
 */
const mouse = new THREE.Vector2()

let currentIntersect = null

window.addEventListener('mousemove', (event) =>
{
    
    mouse.x = event.clientX / sizes.width * 2 - 1
    mouse.y = - (event.clientY / sizes.height) * 2 + 1

})



    
window.addEventListener('click', (event) =>
    {
        if (event.target.tagName === 'A') {
            return;
        }
    
        if (currentIntersect) {
            const targetMesh = currentIntersect.object;
    
            // Animate camera to move to the mesh
            gsap.to(camera.position, {
                duration: 1.4,
                x: targetMesh.position.x,
                y: targetMesh.position.y,
                z: targetMesh.position.z,
                onUpdate: function() {
                    const distance = camera.position.distanceTo(targetMesh.position);
                    if (distance < 1) {
                        // Start the overlay animation
                        gsap.to('#white-overlay', {
                            duration: 1,
                            opacity: 1,
                            onComplete: () => {
                               
                                loadNewScene(targetMesh);
                            }
                        });
                        // Kill the camera animation to prevent further updates
                        this.kill();
                    }
                },
                onComplete: function() {
                    // Ensure the overlay animation starts 
                    gsap.to('#white-overlay', {
                        duration: 0.4,
                        opacity: 1,
                        onComplete: () => {
                           
                            loadNewScene(targetMesh);
                        }
                    });
                }
            });
        }
    });
    
    function loadNewScene(mesh) {
        switch (mesh) {
            case mesh1:
                console.log('Loading scene for Mesh 1');
                window.location.href = '/htmls/about.html';
                break;
            case mesh2:
                console.log('Loading scene for Mesh 2');
                window.location.href = '/htmls/processes.html';
                break;
            case mesh3:
                console.log('Loading scene for Mesh 3');
                window.location.href = '/htmls/work.html';
                break;
            case mesh4:
                console.log('Loading scene for Mesh 4');
                window.location.href = '/htmls/contact.html';
                break;
            case mesh5:
                console.log('Loading scene for Mesh 5');
                window.location.href = '/htmls/services.html';
                break;
        }
    }


// Event listeners to header links
const headerLinks = document.querySelectorAll('header nav a');
headerLinks.forEach(link => {
    link.addEventListener('click', (event) => {
        event.preventDefault();
        const targetUrl = event.target.href;

        // Start the overlay animation
        gsap.to('#white-overlay', {
            duration: 1,
            opacity: 1,
            onComplete: () => {
                window.location.href = targetUrl;
            }
        });
    });
});

// Fade-in effect on page load
window.addEventListener('load', () => {
    document.body.classList.add('loaded');
});


/**
 * Animate
 */
parameters.meshScale = 0.8
let lastRotationTime = 0
const rotationInterval = 4
const clock = new THREE.Clock()
let previousTime = 0

const tick = () => {
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    sectionMeshes.forEach(mesh => {
        mesh.scale.set(parameters.meshScale, parameters.meshScale, parameters.meshScale);
    });
    
    // Animate camera
    camera.position.y = -scrollY / sizes.height * objectsDistance
    
    const parallaxX = mouse.x * 0.5
    const parallaxY = mouse.y * 0.5
    cameraGroup.position.x += (parallaxX - cameraGroup.position.x) * 5 * deltaTime
    cameraGroup.position.y += (parallaxY - cameraGroup.position.y) * 5 * deltaTime
    
    // Animate meshes
    for (const mesh of sectionMeshes) {
        mesh.rotation.x += deltaTime * 0.1
        mesh.rotation.y += deltaTime * 0.12                    
    }
        
    // Update rotation 
    if (elapsedTime - lastRotationTime > rotationInterval) {
    lastRotationTime = elapsedTime;

    // Rotate the "escolha" text
    gsap.to(textMeshEscolha.rotation, {
        duration: 2,
        x: textMeshEscolha.rotation.x + Math.PI * 2, 
        ease: "power4.inOut",
    });

    // Change metalness of the "escolha" text
    gsap.to(textMeshEscolha.material, {
        duration: 2, 
        metalness: 0.6,
        repeat: 1, // Revert after the animation
        yoyo: true, // Smoothly return to the original value
        ease: "power2.inOut",
    });

   
    gsap.to(textMeshDigital.rotation, {
        duration: 2, 
        y: textMeshDigital.rotation.y - Math.PI * 2, 
        ease: "power2.inOut",
    });

    // Change metalness of the "digital" text 
    gsap.to(textMeshDigital.material, {
        duration: 2, 
        metalness: 0.6, 
        repeat: 1, // Revert after the animation
        yoyo: true, // Smoothly return to the original value
        ease: "power2.inOut",
    });
}
    
     // Update raycaster
     raycaster.setFromCamera(mouse, camera);
     const intersects = raycaster.intersectObjects(sectionMeshes);
 
 
     if (intersects.length) {
        if(currentIntersect === null) 

        currentIntersect = intersects[0]
     }
     else if(currentIntersect) {
        currentIntersect = null  
        }

      
    // Update wave particles rotation
    particlesWave.rotation.x = parameters.particlesWaveRotationX
    particlesWave.rotation.y = parameters.particlesWaveRotationY
    particlesWave.rotation.z = parameters.particlesWaveRotationZ

    // Update wave particles position
    particlesWave.position.y = parameters.wavePositionY

    // Update wave particles
    for (let i = 0; i < count; i++) {
        const i3 = i * 3
        const x = particlesWaveGeometry.attributes.position.array[i3]
        particlesWaveGeometry.attributes.position.array[i3 + 1] = Math.sin(elapsedTime * parameters.waveFrequency + x) * parameters.waveAmplitude
    }

    particlesWaveGeometry.attributes.position.needsUpdate = true

    // Render
    renderer.render(scene, camera)
    
    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()